import * as d3 from 'd3';

export class Format {
  static formatTime(stringFormat) {
    const format = stringFormat || '%d %B %Y';
    return d3.timeFormat(format);
  }

  static formatNumber(stringFormat) {
    const format = stringFormat || '.2r';
    return d3.format(format);
  }
}
